import Events from '@utilities/events';

const SUCCESS_CLASS = 'is--success';
const SUCCESS_TIMER = 3000;

class ButtonLoader {
  constructor(element, shouldAnimate = true) {
    this.element = element;
    this.shouldAnimate = shouldAnimate;
  }

  /**
   * Shows the loader
   */
  show() {
    if (!this.element) return;
    this.element.classList.add('disabled');
    this.element.classList.remove(SUCCESS_CLASS);
    this.element.setAttribute('disabled', 'disabled');
    this.element.setAttribute('tabindex', '-1');
    if (this.shouldAnimate) Events.$trigger('loader::show', { data: { target: this.element } });
  }

  /**
   * Hides the loader
   */
  hide(showSucces = false) {
    if (!this.element) return;
    if (this.shouldAnimate) Events.$trigger('loader::hide');
    this.element.classList.remove('disabled');
    this.element.removeAttribute('disabled');
    this.element.removeAttribute('tabindex');
    if (this.shouldAnimate) this.element.focus();

    if (showSucces) {
      this.element.classList.add(SUCCESS_CLASS);
      setTimeout(() => {
        this.element.classList.remove(SUCCESS_CLASS);
      }, SUCCESS_TIMER);
    }
  }
}

export default ButtonLoader;
